/**
 * In-app notification list.
 *
 * This, not push, is the system of record. A captain who never granted
 * notification permission -- or who is on an iPhone and never added the app to
 * their home screen -- still sees every decision here.
 */

import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { Empty, Spinner } from '@abg/ui'
import { relative } from '@abg/ui/time'
import { api } from '../lib/api'
import { cached } from '../lib/offline'
import type { Notification } from '../lib/types'

export function NotificationsPage() {
  const [items, setItems] = useState<Notification[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    void cached('notifications', () => api.get<Notification[]>('/api/push/notifications'))
      .then((result) => setItems(result.data))
      .catch(() => undefined)
      .finally(() => setLoading(false))
  }, [])

  if (loading) return <div className="page"><Spinner label="Loading…" /></div>

  return (
    <div className="page">
      <header className="page-header">
        <h1>Notifications</h1>
        <span className="subtitle">Everything we have sent you, whether or not it reached your lock screen.</span>
      </header>

      {items.length === 0 && <Empty>Nothing yet.</Empty>}

      <section className="list">
        {items.map((item) => {
          const body = (
            <>
              <div className="row-between">
                <span className="title">{item.title}</span>
                <span className="caption">{relative(item.created_at)}</span>
              </div>
              <div className="small">{item.body}</div>
            </>
          )
          return item.application_id ? (
            <Link key={item.id} to={`/applications/${item.application_id}`} className="list-row">
              {body}
            </Link>
          ) : (
            <div key={item.id} className="list-row">
              {body}
            </div>
          )
        })}
      </section>
    </div>
  )
}
